<mdb-sidenav-layout>
  <mdb-sidenav #sidenav="mdbSidenav"
               id="sidenav1"
               [mode]="sidenavService.isOverMode() ? 'over' : 'side'"
               [hidden]="false">
    <div id="header-content">
      <img
        src="../../../../assets/images/logo.png"
        alt="Logo"
        class="sidenav-logo"
      />
    </div>
    <hr class="m-0"/>
    <ul class="sidenav-menu">
      @for (item of items; track item) {
        <app-sidenav-item
          [text]="item.text"
          [link]="item.path"
        (onClick)="itemClick(item)"></app-sidenav-item>
      }
    </ul>
  </mdb-sidenav>
  <mdb-sidenav-content #sidenavContent>

    <!-- Navbar -->
    <nav id="main-navbar"
         [class.sidenav-hidden]="sidenavService.isHidden()"
         [class.sidenav-shown]="!sidenavService.isHidden()"
         class="navbar navbar-expand-lg navbar-light bg-white fixed-top">
      <!-- Container wrapper -->
      <div class="container-fluid">
        <!-- Toggler -->
        <button
          class="btn shadow-0 p-0 me-3 d-block"
          aria-controls="#sidenav-1"
          aria-haspopup="true"
          (click)="sidenavService.isHidden() ? sidenavService.show() : sidenavService.hide()">
          <i class="fas fa-bars fa-lg"></i>
        </button>

        <!--        <h5 class="m-0">{{activeItem.text|translate}}</h5>-->
        <app-breadcrumbs></app-breadcrumbs>

        <!-- Right links -->
        <ul class="navbar-nav ms-auto d-flex flex-row align-items-center">
          <li class="mx-2">
            <app-language-select></app-language-select>
          </li>

          <!-- Icon -->
          <li class="nav-item">
            <app-mdb-button [text]="!sidenavService.isOverMode ? 'AUTH.LOGOUT' : undefined"
              iconClass="fas fa-sign-out-alt"
              color="secondary"
              [outlined]="true"
              [loading]="logoutLoading"
            (onClick)="logout()"></app-mdb-button>
          </li>
        </ul>
      </div>
      <!-- Container wrapper -->
    </nav>
    <!-- Navbar -->

    <main class="bg-light">
      <ng-content></ng-content>
    </main>

  </mdb-sidenav-content>
</mdb-sidenav-layout>
